import * as numbers from "common/numbers";

// Step and sub-step names written by scripts/demo_data/progress.py on the worker
const PROGRESS_LABELS = {
  fetch: {
    list: "Listing submissions",
    resolved: "Fetching resolved submissions",
    raw: "Fetching raw submissions",
  },
  classify: {
    raw: "Classifying raw fields",
    resolved: "Classifying resolved fields",
  },
  enrich: { default: "Enriching fields" },
  render: { model: "Writing model.py", schema: "Writing schema.json" },
  generate: { default: "Generating submissions" },
  load: { default: "Loading submissions" },
};

const PROGRESS_UNITS = {
  fetch: "submissions",
  classify: "batches",
  enrich: "batches",
  generate: "submissions",
  load: "submissions",
};

const count = numbers.dpString(0);

const hasTotal = (progress) =>
  Number.isFinite(progress?.done) &&
  Number.isFinite(progress?.total) &&
  progress.total > 0;

export const progressLabel = (progress) => {
  if (!progress?.step) return null;
  const labels = PROGRESS_LABELS[progress.step];
  return labels?.[progress.sub] ?? labels?.default ?? progress.step;
};

export const progressCount = (progress) => {
  if (!hasTotal(progress)) return null;
  const unit = PROGRESS_UNITS[progress.step];
  return `${count(progress.done)} / ${count(progress.total)}${
    unit ? ` ${unit}` : ""
  }`;
};

export const progressPercent = (progress) =>
  hasTotal(progress)
    ? numbers.clamp((progress.done / progress.total) * 100, 0, 100)
    : null;

export const progressAge = (progress, now = Date.now()) => {
  const updated = Date.parse(progress?.updated_at);
  if (!Number.isFinite(updated)) return null;
  const seconds = Math.max(0, Math.round((now - updated) / 1000));
  if (seconds < 60) return `updated ${count(seconds)}s ago`;
  const mins = Math.floor(seconds / 60);
  if (mins < 60) return `updated ${count(mins)}m ago`;
  return `updated ${count(Math.floor(mins / 60))}h ${count(mins % 60)}m ago`;
};
